/**
 * @generated SignedSource<<720f7f94c2c45cc2c49ea534ba9005c3>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type pantoneLibraryPage_palettesWithColorsQuery$variables = Record<PropertyKey, never>;
export type pantoneLibraryPage_palettesWithColorsQuery$data = {
  readonly palettesWithColors: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly isZakekeDefault: boolean;
        readonly name: string;
        readonly paletteTypeID: number;
        readonly useConversionTable: boolean;
      };
    }> | null;
  } | null;
};
export type pantoneLibraryPage_palettesWithColorsQuery = {
  response: pantoneLibraryPage_palettesWithColorsQuery$data;
  variables: pantoneLibraryPage_palettesWithColorsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "PalettesWithColorsConnection",
    "kind": "LinkedField",
    "name": "palettesWithColors",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PalettesWithColorsEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Palette",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "useConversionTable",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "paletteTypeID",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isZakekeDefault",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "pantoneLibraryPage_palettesWithColorsQuery",
    "selections": (v0/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "pantoneLibraryPage_palettesWithColorsQuery",
    "selections": (v0/*:: as any*/)
  },
  "params": {
    "cacheID": "38f966fa509ed130aee9042959d65340",
    "id": null,
    "metadata": {},
    "name": "pantoneLibraryPage_palettesWithColorsQuery",
    "operationKind": "query",
    "text": "query pantoneLibraryPage_palettesWithColorsQuery {\n  palettesWithColors {\n    edges {\n      node {\n        id\n        name\n        useConversionTable\n        paletteTypeID\n        isZakekeDefault\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "af97615f9c42eeab980435f8931ce681";

export default node;
